import React, { useState, useRef } from "react";
import classnames from "classnames";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  NavbarBrand,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { useLocation, useNavigate } from "react-router-dom";
import img from "assets/img/icons/dashboard2.jpg";
import { useAuth } from "context/AuthContext";
import { REGEX, ROLES, DEFAULT_ROUTES } from "variables/constants";
import { validateUrlUuid } from "actions/users";
import { BrandLogo } from "components/BrandLogo/BrandLogo";
import { SideBarLogoForLogin } from "components/BrandLogo/BrandLogo";
// import BrandLogo from "components/BrandLogo/BrandLogo";

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const notificationAlertRef = useRef(null);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const urlUuidId = queryParams.get("uuid"); // 👈 THIS IS THE ID
  const [focusedEmail, setFocusedEmail] = useState(false);
  const [focusedPassword, setFocusedPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  //==> This useEffect is used for check UUID if is avilable then UUID will validate and navigate to dashboard to set a password.
  React.useEffect(() => {
    const initLogin = async () => {
      if (!urlUuidId) return;
      localStorage.removeItem("p");
      setLoading(true);

      const res = await validateUrlUuid(urlUuidId);

      if (res.code !== 200) {
        notify("danger", res.message);
        setLoading(false);
        return;
      }

      const userData = {
        ...res.data,
      };
      localStorage.setItem("p", JSON.stringify(userData));
      const auth = JSON.stringify(userData);
      if (!auth) {
        notify("danger", "Invalid login response");
        setLoading(false);
        return;
      }
      const matchedKey = Object.keys(ROLES).find(
        (key) => ROLES[key] === userData.role,
      );
     
      if (!matchedKey) {
        notify("danger", "Unauthorized role");
        setLoading(false);
        return;
      }
      notify("success", "Login successful");

      const redirect = DEFAULT_ROUTES[matchedKey] || "/admin/dashboard";
            window.location.replace(redirect);
      
      setLoading(false);
    };

    initLogin();
  }, [urlUuidId]);

  // React.useEffect(() => {
  //   const stored = localStorage.getItem("p");
  //   if (stored) {
  //     navigate(
  //       ROLES.superAdmin === JSON.parse(stored).role || ROLES.admin=== JSON.parse(stored).role
  //         ? "/admin/dashboard"
  //         : "/publisher/dashboard"
  //     );
  //   }
  // }, []);

  //==> notify function is used for show notification login success or error.
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  //==> handleChange function is used for set the form values in a state.
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value.trim() });
  };

  //==> validate function is used for check email is valid or not.
  const validate = () => {
    if (!form.email) {
      notify("danger", "Email is required");
      return false;
    }
    if (!REGEX.EMAIL_REGEX.test(form.email)) {
      notify("danger", "Please enter a valid email");
      return false;
    }
    if (!form.password) {
      notify("danger", "Password is required");
      return false;
    }
    return true;
  };

  //==> handleLogin function is used for perform login.
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    const res = await login(form);
    if (res.code != 200) {
      notify("danger", res.message);
      setLoading(false);
      return;
    }
    // get stored user from `p`
    const auth = JSON.parse(localStorage.getItem("p"));
    if (!auth) {
      notify("danger", "Invalid login response");
      setLoading(false);
      return;
    }

    // role validation
    const matchedKey = Object.keys(ROLES).find(
      (key) => ROLES[key] === auth.role,
    );
    if (!matchedKey) {
      notify("danger", "Unauthorized role");
      setLoading(false);
      return;
    }

    notify("success", "Login successful");

    const redirect = DEFAULT_ROUTES[matchedKey] || "/admin/dashboard";
    setTimeout(() => {
      navigate(redirect);
    }, 800);

    setLoading(false);
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <div className="login-page">
        {/* BACKGROUND IMAGE */}
        <div
          className="login-bg-image"
          style={{ backgroundImage: `url(${img})` }}
        />

        {/* GRADIENT OVERLAY */}
        <div className="login-bg-overlay" />

        {/* CONTENT */}
        <Container fluid className="login-content">
          <Row className="min-vh-100 align-items-center">
            {/* LEFT */}
            <Col
              lg="6"
              className="d-none d-lg-flex align-items-center justify-content-center"
            >
              <div className="login-brand">
                <NavbarBrand className="p-0">
                  {/* <div className="display-1 font-weight-bold text-info text-center">
                    TrueLift Media
                  </div> */}
                  <BrandLogo />
                </NavbarBrand>
              </div>
            </Col>

            {/* RIGHT */}
            <Col
              lg="6"
              md="6"
              className="d-flex justify-content-center align-items-center"
            >
              <div className="login-card-wrapper">
                {/* Logo visible only on small screens (mobile/tablet) */}
                <div className="text-center mb-4 d-block d-lg-none">
                  <NavbarBrand className="p-0">
                    <SideBarLogoForLogin />
                  </NavbarBrand>
                </div>
                
                <Card className="border-0 shadow-lg rounded-lg py-5">
                  <CardBody className="login-card-body">
                    {/* Logo hidden on small screens since it's now above the card */}
                    <div className="text-center mb-4 d-none d-lg-block">
                      <h2 className="font-weight-bold mb-1">Sign In</h2>
                    </div>
                    
                    {/* On small screens, show the title only (no logo inside card) */}
                    <div className="text-center mb-4 d-block d-lg-none">
                      <h2 className="font-weight-bold mb-1">Sign In</h2>
                    </div>

                    <Form onSubmit={handleLogin}>
                      {/* EMAIL */}
                      <FormGroup
                        className={classnames("mb-3", {
                          focused: focusedEmail,
                        })}
                      >
                        <InputGroup className="input-group-merge">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-email-83" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            name="email"
                            type="email"
                            placeholder="Email"
                            bsSize="lg"
                            value={form.email}
                            onChange={handleChange}
                            onFocus={() => setFocusedEmail(true)}
                            onBlur={() => setFocusedEmail(false)}
                            autoComplete="off"
                          />
                        </InputGroup>
                      </FormGroup>

                      {/* PASSWORD */}
                      <FormGroup
                        className={classnames("mb-3", {
                          focused: focusedPassword,
                        })}
                      >
                        <InputGroup className="input-group-merge">
                          {/* Lock icon */}
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-lock" />
                            </InputGroupText>
                          </InputGroupAddon>

                          {/* Password input */}
                          <Input
                            name="password"
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            bsSize="lg"
                            value={form.password}
                            onChange={handleChange}
                            onFocus={() => setFocusedPassword(true)}
                            onBlur={() => setFocusedPassword(false)}
                            autoComplete="new-password"
                            
                          />

                          {/* Eye icon */}
                          <InputGroupAddon addonType="append">
                            <InputGroupText
                              style={{ cursor: "pointer" }}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => setShowPassword((p) => !p)}
                            >
                              <i
                                className={
                                  showPassword ? "fa fa-eye-slash" : "fa fa-eye"
                                }
                              />
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>

                      <div className="d-flex justify-content-end mb-4">
                        <button
                          type="button"
                          className="btn btn-link p-0 small font-weight-bold"
                          onClick={() => navigate("/auth/forgot-password")}
                          style={{ color: "#00acb4" }}
                        >
                          Forgot password?
                        </button>
                      </div>

                      {/* SIGN IN */}
                      <Button
                        block
                        // color="primary"
                        style={{ backgroundColor: "#00acb4", color: "#f6f7f8" }}
                        size="lg"
                        type="submit"
                        disabled={loading}
                        className="mt-4"
                      >
                        {loading ? (
                          <i className="fa fa-spinner fa-spin" />
                        ) : (
                          "Sign In"
                        )}
                      </Button>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Login;
